import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Observable, switchMap, tap } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';

@Injectable()
export class LoginFacadeService {
  private authService = inject(AuthService);
  private userService = inject(UserService);
  private router = inject(Router);

  buildLoginForm(): FormGroup {
    return this.authService.getLoginForm();
  }

  /**
   * Orquesta el flujo completo de login:
   * 1. Autenticación → setea sesión y datos de usuario.
   * 2. Obtención de compañías → setea businessGroupId y companyId.
   * 3. Navegación al dashboard.
   */
  login(form: FormGroup): Observable<any> {
    return this.authService.login().pipe(
      tap((response: any) => {
        const data = response?.data ?? {};
        this.authService.setSession(data?.accessToken, data?.refreshToken);
        this.authService.startTokenRefresh();
        this.userService.setUserName(data?.userName);
        this.userService.setUserData({
          email: data?.userName,
          fullName: data?.fullName,
          mainRole: data?.jobTitle,
          phone: data?.mobilePhone,
        });
      }),
      switchMap((response: any) =>
        this.userService.getCompanies(response?.data?.userName).pipe(take(1)),
      ),
      tap((companiesResponse: any) => {
        const companies = companiesResponse?.data ?? [];
        if (companies.length) {
          this.userService.setBusinessGroupId(companies[0].grupoEmpresarialId);
          this.userService.setCompanyId(companies[0].empresaID, false);
        }
        this.goToHome();
      }),
    );
  }

  logout(): void {
    this.authService.logout();
  }

  private goToHome(): void {
    this.router.navigate(['/dashboard']);
  }
}
